"use client";

// Состояние, которое переживает перезагрузку страницы.
//
// ЗАЧЕМ. Внутренние вкладки экранов («Вакансии / Кандидаты / Воронка», разделы
// модулей) жили в обычном useState, и F5 всегда возвращал на первую вкладку.
// Пользователь сидит в «Кандидатах», обновляет страницу — и оказывается в
// «Вакансиях» (Максим, 27.08.2026). Раздел ОТДЕЛА восстанавливался и раньше
// (lib/dept-nav), а вкладки внутри модуля — нет.
//
// Ключ обязателен и должен быть уникальным на экран: `hr:hiring:sub`.

import { useEffect, useState } from "react";

const PREFIX = "company-portal:view:";

export function useStickyState<T extends string>(key: string, initial: T): [T, (v: T) => void] {
  // ⚠️ Первый рендер отдаёт `initial`, а не значение из хранилища: на сервере
  // localStorage нет, и чтение прямо в инициализаторе даёт расхождение разметки
  // (hydration mismatch). Восстанавливаем в эффекте — на кадр позже, зато честно.
  const [value, setValue] = useState<T>(initial);

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem(PREFIX + key);
      if (saved) setValue(saved as T);
    } catch { /* приватный режим — просто не восстановим */ }
  }, [key]);

  const set = (v: T) => {
    setValue(v);
    try { window.localStorage.setItem(PREFIX + key, v); } catch { /* см. выше */ }
  };

  return [value, set];
}
